<template>
  <b-container class="mt-5 etusivu">
    <b-row>
      <b-col lg="8" offset-lg="2">
        <h1 class="mb-4">Pelejä helpolla suomella</h1>
        <p>Tällä sivulla on pelejä,<br/>joiden kieli on helppoa.<br/>Pelien avulla voit testata,<br/>kuinka hyvin tunnet tekijänoikeudet.</p>
        <p>Onnenpyörän kysymykset ovat tekijänoikeuden perusasioita.<br/>Hedelmäpelin sisältö on vaikeampi.</p>
       <p>Pelien kysymyksissä jotkut sanat on alleviivattu.<br/>Jos napautat sanaa,<br/>näet selityksen sanastossa.</p>
        <b-container >
          <b-row>
            <b-col lg="12" class="p-0">
              <p><a href="#sanasto">Tutustu sanastoon</a></p>
            </b-col>
            <b-col lg="12" class="p-0">
              <p><a href="#" @click="showInfo = !showInfo">Lisätietoa opettajalle yleiskielellä</a></p>
              <b-card v-if="showInfo">Onnenpyörän sisältö vastaa perusopetuksen valtakunnallisen opetussuunnitelman 3.–6. vuosiluokkien tekijänoikeustaitojen tavoitteita ja Hedelmäpelin sisältö siitä ylöspäin toisen asteen tavoitteisiin asti.
Peleissä saa pisteitä oikeista vastauksista sekä bonuspisteitä jäljelle jääneistä elämistä. Hedelmäpelissä kolme samaa kuviota tai vähintään kaksi c-merkkiä avaa kysymyksen. Jokaisella kuviolla on eri pistemäärä.
</b-card>
            </b-col>
          </b-row>
          <b-row class="mt-5 pt-3">
            <b-col lg="6" class="p-0">
              <h2>Onnenpyörä</h2>
              <ul>
                <li>Sinulla on kolme elämää.</li>
                <li>Elämät näkyvät sydänkuvioina pelin vasemmassa yläreunassa.</li>
                <li>Väärästä vastauksesta ja pääkallosta menetät elämän.</li>
                <li>Jos menetät kaikki elämäsi, peli päättyy.</li>
                <li>Tehtäviä tulee kymmenen.</li>
              </ul>
            </b-col>
            <b-col lg="6" class="text-center">
              <img src="../assets/icon_onnenpyora.png" class="image-fit" />
              <router-link to="/onnenpyora">
                <b-button class="btn-round btn-red mt-4">PELAA</b-button>
              </router-link>
            </b-col>
          </b-row>
          <b-row class="mt-5 pt-3">
            <b-col lg="6" class="p-0">
              <h2>Hedelmäpeli</h2>
              <ul>
                <li>Sinulla on kolme elämää.</li>
                <li>Elämät näkyvät sydänkuvioina pelin vasemmassa yläreunassa.</li>
                <li>Väärästä vastauksesta menetät elämän.</li>
                <li>Jos menetät kaikki elämäsi, peli päättyy.</li>
                <li>Tehtäviä tulee kymmenen.</li>
              </ul>
            </b-col>
            <b-col lg="6" class="text-center">
              <img src="../assets/icon_slotmachine.png" class="image-fit" />
              <router-link to="/hedelmapeli">
                <b-button class="btn-round btn-red mt-4">PELAA</b-button>
              </router-link>
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>
    <b-row class="mt-5 pt-3">
      <b-col lg="8" offset-lg="2" class="sanasto">
        <a name="sanasto" />
        <h2>Sanastoa tekijänoikeuksista</h2>
        <p class="mb-5">Tässä sanastossa on tekijänoikeuksiin liittyviä sanoja,<br/>joita käytetään peleissä.</p>
        <h3>Creative Commons –lisenssi:</h3>
        <p>Tekijä voi laittaa teokseensa CC-lisenssin.</p>
        <p>CC-lisenssi tarkoittaa,</p>
        <p>että tekijä antaa luvan käyttää teosta tietyillä ehdoilla.</p>
        <p>CC-lisenssillä tekijä voi antaa luvan</p>
        <p>esimerkiksi oman teoksen jakamiseen tai muokkaamiseen.</p>

        <h3>Julkinen esittäminen:</h3>
        <p>Julkinen esittäminen tarkoittaa,</p>
        <p>että teosta (esimerkiksi elokuvaa) näytetään yleisölle.</p>

        <h3>Julkinen paikka:</h3>
        <p>Julkinen paikka on paikka,</p>
        <p>jonne kaikki saavat mennä.</p>
        <p>Julkisia paikkoja ovat esimerkiksi kirjastot ja puistot.</p>

        <h3>Laki / laillinen / laiton:</h3>
        <p>Laki on valtion sääntö,</p>
        <p>jota pitää noudattaa.</p>
        <p>Jos teko noudattaa lakia,</p>
        <p>se on laillinen.</p>
        <p>Jos teko rikkoo lakia,</p>
        <p>se on laiton.</p>
        <p>Jos rikkoo lakia,</p>
        <p>saa rangaistuksen.</p>
        <p>Lain mukaan tekijänoikeuksia pitää noudattaa.</p>

        <h3>Luova työ:</h3>
        <p>Luova työ on sellaista työtä,</p>
        <p>johon ihminen käyttää omia ideoitaan ja taitojaan.</p>
        <p>Luovan työn tulos voi olla esimerkiksi tarina, maalaus, elokuva tai musiikkia.</p>
        <p>Luovan työn tulos ei ole koskaan kopio toisen työstä.</p>

        <h3>Lähde:</h3>
        <p>Lähde tarkoittaa sitä paikkaa,</p>
        <p>josta esimerkiksi teksti tai tieto on otettu.</p>
        <p>Lähde voi olla esimerkiksi kirja, internetsivu tai ihminen.</p>
        <p>Lähde pitää aina ilmoittaa.</p>
        <p>Tämä tarkoittaa, että pitää esimerkiksi kertoa,</p>
        <p>mitä internetsivua tai kirjaa on käyttänyt.</p>
        <p>Tekijän nimi pitää aina kertoa,</p>
        <p>kun käyttää esimerkiksi toisen tekstiä tai kuvaa.</p>

        <h3>Perillinen:</h3>
        <p>Perillinen on se ihminen,</p>
        <p>jolle kuolleen ihmisen omaisuus siirtyy.</p>
        <p>Perillisiä on usein monta.</p>

        <h3>Tekijä:</h3>
        <p>Ihminen, joka on tehnyt luovan teoksen.</p>

        <h3>Tekijänoikeus:</h3>
        <p>Tekijänoikeus tarkoittaa sitä,</p>
        <p>että tekijä saa suojaa omalle työlleen.</p>
        <p>Tekijänoikeuksien vuoksi toisen teosta ei saa käyttää vapaasti.</p>

        <h3>Teos:</h3>
        <p>Teos on luovan työn tulos.</p>
        <p>Teos voi olla esimerkiksi kirjoitus, kuvataidetyö, video tai musiikkia.</p>

        <h3>Teoskynnys:</h3>
        <p>Kaikki työt eivät saa tekijänoikeussuojaa.</p>
        <p>Silloin sanotaan,</p>
        <p>että teos ei ylitä teoskynnystä.</p>
        <p>Jos piirrät paperille viivan kynällä,</p>
        <p>se ei ylitä teoskynnystä.</p>
        <p>Teoksen pitää olla omaperäinen ja itsenäinen.</p>
        <ul>
          <li>Itsenäinen = teos ei ole toisen teoksen kopio.</li>
          <li>Omaperäinen = teoksessa näkyy tekijänsä persoonallinen jälki.</li>
        </ul>
        <h3>Yksityinen käyttö:</h3>
        <p>Yksityinen käyttö tarkoittaa,</p>
        <p>että käyttää jotain vain yksin,</p>
        <p>perheen tai läheisten kavereiden kanssa.</p>
      </b-col>
    </b-row>
    <b-row class="mt-5">
    </b-row>
  </b-container>
</template>

<script>
export default {
  components:
  {
  },
  name: 'Etusivu',
  data: function () {
    return {
      showInfo: false
    }
  },
  watch: {
  },
  methods: {
  },
  created: function () {}
}
</script>

<style>
.etusivu p{
    font-size: 1.2rem;
 }
.image-fit{
  width: 100%;
  height: auto;
  border-radius: 16px;
}
.etusivu ul{
  padding: 1em 1.5em;
}
.etusivu li{
  font-size: 1.2rem;
  margin-bottom: 1em;
}
.sanasto p{
  margin: 0;
}
.sanasto h3{
  margin: 2em 0 0.5em 0;
}
.sanasto li{
  font-size: 1.1rem;
  margin-bottom: 0.5em;
}
.sanasto ul{
  padding-top: 0.5em;
}
</style>



// WEBPACK FOOTER //
// src/components/Etusivu.vue